import { c as _c } from "react/compiler-runtime";
import React from "react";
import { TabItem } from "./TabItem";
import type { IconName } from "@/types/icons";
import type { ThemeVariant } from "@/types/common";
interface Tab {
  id: string;
  label: string;
  icon?: IconName;
}
interface VerticalTabBarProps {
  tabs: Tab[];
  activeTabId: string;
  variant?: ThemeVariant;
  onTabChange: (id: string) => void;
  className?: string;
}

/**
 * Vertical tab bar component
 */
export const VerticalTabBar: React.FC<VerticalTabBarProps> = t0 => {
  const $ = _c(12);
  const {
    tabs,
    activeTabId,
    variant: t1,
    onTabChange,
    className: t2
  } = t0;
  const variant = t1 === undefined ? "light" : t1;
  const className = t2 === undefined ? "" : t2;
  const t3 = `flex flex-wrap lg:flex-nowrap lg:flex-col items-start gap-sm ${className} sticky top-0 lg:py-3xl`;
  let t4;
  if ($[0] !== activeTabId || $[1] !== onTabChange || $[2] !== tabs || $[3] !== variant) {
    let t5;
    if ($[5] !== activeTabId || $[6] !== onTabChange || $[7] !== variant) {
      t5 = tab => <TabItem key={tab.id} label={tab.label} icon={tab.icon} isActive={tab.id === activeTabId} variant={variant} onClick={() => onTabChange(tab.id)} />;
      $[5] = activeTabId;
      $[6] = onTabChange;
      $[7] = variant;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    t4 = tabs.map(t5);
    $[0] = activeTabId;
    $[1] = onTabChange;
    $[2] = tabs;
    $[3] = variant;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <nav className={t3}>{t4}</nav>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};